export default __webpack_public_path__ + "static/media/getwell-logo-menu.5db7c2ce.png";